import { ChevronDownUnsorted, ChevronDown, ChevronUp, DippiQRCode } from "@dippi/icons";
import React, { useCallback } from "react";
import { useTableHelper } from "./hooks";
import { Styled } from "./styles";
import Toolbar from "./toolbar";
import Pagination from "./pagination";
import Modal from "./modal";
import { SortModel, useTable } from "@/context/table";
import { isArrayWithData } from "@/utils/validations";
import { GridSortModel } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import useQueryProducts from "@/hooks/queries/useQueryProducts";

const Table: React.FC = () => {
    const { data, isFetching } = useQueryProducts();
    const { paginationModel, sortModel, setSort } = useTable();
    const { rows, columns, onOpenProduct, getRowSpacing } = useTableHelper();

    const { page, pageSize } = paginationModel;
    const hideFooter = pageSize * page === 0 && !isArrayWithData(data);
    const rowCount = pageSize * page;

    const onSortChange = useCallback((model: GridSortModel) => {
        const sortModel = model[0];

        if (sortModel && sortModel.field && sortModel.sort) {
            const sortModelObject: SortModel = { sort: sortModel.sort, field: sortModel.field };

            return setSort(sortModelObject);
        }
        return setSort({ field: "createdAt", sort: "desc" });
    }, []);

    return (
        <React.Fragment>
            <Styled.Table
                rows={rows(data)}
                columns={columns()}
                loading={!data && isFetching}
                disableColumnFilter={true}
                disableColumnSelector={true}
                showColumnVerticalBorder={true}
                disableRowSelectionOnClick={true}
                disableColumnMenu={true}
                filterMode="server"
                paginationMode="server"
                sortingMode="server"
                pagination={true}
                hideFooter={hideFooter}
                onRowClick={params => {
                    const _id = params.row._id;
                    const typeName = params.row.typeName;
                    onOpenProduct(typeName, _id);
                }}
                getRowId={row => row._id}
                hideFooterSelectedRowCount={true}
                columnHeaderHeight={40}
                rowCount={rowCount}
                getRowHeight={() => "auto"}
                initialState={{
                    pagination: { paginationModel },
                    sorting: {
                        sortModel: [sortModel],
                    },
                }}
                onSortModelChange={onSortChange}
                getRowSpacing={getRowSpacing}
                slots={{
                    toolbar: Toolbar,
                    noRowsOverlay: () => (
                        <Box flex={1} display="flex" alignItems="center" justifyContent="center">
                            <DippiQRCode />
                        </Box>
                    ),
                    columnSortedAscendingIcon: () => <ChevronUp />,
                    columnSortedDescendingIcon: () => <ChevronDown />,
                    columnUnsortedIcon: () => <ChevronDownUnsorted />,
                    pagination: () => {
                        if (!data) return null;

                        return <Pagination data={data} isFetching={isFetching} />;
                    },
                }}
            />
            <Modal />
        </React.Fragment>
    );
};

export default Table;
